import { API_ROOT } from 'core/config/constants';

let service: string | undefined;

// Which service this app's own API calls go to: sign-fe and group-fe use 'sign', payroll-fe 'payroll'. The apps
// differ here; the environments do not. Call it once, before the app makes a request.
export const setOwnService = (name: string) => {
  service = name;
};

export const ownServiceBase = () => {
  if (!service) {
    throw new Error('setOwnService was not called before the first API request');
  }
  return `${API_ROOT}/${service}/v1`;
};

export const ownServiceUnversionedBase = () => {
  if (!service) {
    throw new Error('setOwnService was not called before the first API request');
  }
  return `${API_ROOT}/${service}`;
};
